import {
    MULTIPART_TLDS,
    REGULATIONS,
} from '../components/ReportEventForm/ReportRadios/constants';

export { MULTIPART_TLDS, REGULATIONS };

/**
 * Returns the effective top-level domain (TLD) of the current `window.location`.
 * Handles multi-segment TLDs (e.g. "co.uk")
 */
export const getTld = (): string => {
    let tld = '';

    if (typeof window !== 'undefined') {
        const host = window.location.origin
            .replace(/^https?:\/\//, '')
            .split('/')[0];
        // Break the hostname into its dot-separated segments (e.g. ["www","eventbrite","co","uk"])
        const hostSegments = host?.split('.') ?? [];
        // Attempt to match multipart TLDs first (e.g. "co.uk"). If none match, fall back to the last segment.
        const multipartTLD = hostSegments.slice(-2).join('.') ?? '';
        tld = MULTIPART_TLDS.includes(multipartTLD)
            ? multipartTLD
            : hostSegments.pop() || '';
    }

    return tld;
};

/*
 * Computes the applicable regulation flag (e.g. "EU DSA", "UK OSA") for the
 * given event country and user-side information.
 *
 * @param country       Country code for the event location
 * @param userCountry   Country name inferred from the user’s IP
 * @returns The regulation flag label or an empty string if none apply.
 */
export const computeRegulationLabel = (
    country: string,
    userCountry: string,
): string => {
    const tld = getTld();
    const regulation = REGULATIONS.find(
        ({ eventLocation, tlds, ipLocation }) =>
            eventLocation.includes(country) ||
            tlds.includes(tld) ||
            ipLocation.includes(userCountry),
    );

    return regulation ? regulation.label : '';
};
